import { ChangeEventHandler, useRef } from 'react'

import CodeIcon from '@/assets/icons/code.svg?react'
import DeleteIcon from '@/assets/icons/delete.svg?react'
import UploadIcon from '@/assets/icons/upload.svg?react'
import { Trans } from '@/components'

interface FileInputProps {
  onChange?: ChangeEventHandler<HTMLInputElement>
  fileName?: string
  fileSize?: string
  onDelete?: () => void
  isValidFile?: boolean
}

export function FileInput({ onChange, fileName, fileSize, onDelete, isValidFile }: FileInputProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleDelete = () => {
    // Reset input value to allow selecting the same file again
    if (inputRef.current) {
      inputRef.current.value = ''
    }
    onDelete?.()
  }

  return (
    <label className="flex items-center gap-4 px-4 py-3 border border-neutral-400 rounded-lg cursor-pointer t-sb text-tertiary">
      <div
        className={`flex items-center justify-center p-2.5 rounded-lg ${fileName && isValidFile ? 'bg-success/10' : 'bg-neutral-100'}`}
      >
        {fileName && isValidFile ? (
          <CodeIcon className="w-7 h-7 text-success" />
        ) : (
          <UploadIcon className="w-7 h-7" />
        )}
      </div>
      {fileName ? (
        <div className="flex-1 flex flex-col space-y-1">
          <span className="text-primary t-sb">{fileName}</span>
          <span className="text-tertiary t-x-sb">{fileSize}</span>
        </div>
      ) : (
        <span className="flex-1">
          <Trans i18nKey="customImage.uploadModal.clickToSelect">Click to select an image</Trans>
        </span>
      )}
      {fileName && onDelete && (
        <DeleteIcon
          className="w-6 h-6 cursor-pointer"
          onClick={(e) => {
            e.preventDefault()
            handleDelete()
          }}
        />
      )}
      <input ref={inputRef} type="file" className="!hidden" onChange={onChange} />
    </label>
  )
}
